import React, { Component } from "react";
import style from "../../Styles/Containers/Detail.module.css";
import { withTranslation } from "react-i18next";

import Header from "../../Components/Header/header";
import Section from "../../Components/Section";
import ProductBanner from "../../Components/ProductBanner";
import TapSelector from "../../Components/TapSelector";
import HistoryList from "../../Components/HistoryList";

import { action } from '../../Data';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { parseUrlParameter } from "../../Lib/Utils";
import ModalBarcode from '../Sample/ModalBarcodeSample';
import * as Const from "../../Data/const";
import LoginComponent from "../Authentication";

class DetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLogin: true,

      selectedTap: 0,
      confirmDetailList: [],
      confirmDetailItem: {},
      logEventList: [],
      product: {},
      codeProduct: {},

      showModal: false,
    };

    this.getConfirmDetail = this.getConfirmDetail.bind(this);
    this.handleModal = this.handleModal.bind(this);
  }

  componentDidMount() {
    if (!this.props.eSESSION.user) {
      this.setState({
        isLogin: false,
      }, () => {return;})
    } else {
      this.setState({
        locale: this.props.COUNTRY_CODE,
      }, () => {
        this.getConfirmDetail();
      })
    }
  }

  async getConfirmDetail() {
    let params = parseUrlParameter.parse(this.props.location.search);
    let { user } = this.props.eSESSION;

    let actionParams = {
      productReleaseCode: params.productReleaseCode,
      uuid: this.props.UUID || '',
      uid: user.uid,
      skip: 0,
      limit: 5,
      ELocale: this.state.locale
    }

    console.log(actionParams,'actionParams')

    this.props.dispatch(action.eUSER.getProductInfo(actionParams)).then((res) => {
      console.log(res,'getProductInfo');
      this.setState({
        confirmDetailList: res.logProductConfirmList || [],
        confirmDetailItem: res.logProductConfirmList[0] || {},
        codeProduct: res.codeProduct || {},
        product: res.product || {},
        logEventList: res.logEventList || []
      })
    }).catch((err) => {
      if (err.response) {
        let errData = Const.getError(err.response.data, this.props.COUNTRY_CODE);
        if (!errData.code) {
          Const.showAlert('', errData.errorMessage);
          return;
        } else {
          Const.showAlert('', errData.errorMessage);
          Const.userAppCloseActivity();
        }
      } else {
        console.log('Unknown err', err)
      }
    })
  }

  handleModal(item) {
    this.setState({
      selectedItem: item,
    }, () => {
      console.log(item);
      this.setState({
        showModal: !this.state.showModal
      })
    });
  }

  onClickTap(index) {
    this.setState({ selectedTap: index });
  }

  get renderProductSummary() {
    let params = parseUrlParameter.parse(this.props.location.search);

    return (
      <Section customStyle={{height: 'auto'}}>
        <ProductBanner description={this.props.t('product_code')} imageUrlList={(this.state.product[this.state.locale] || {}).images}
                       code={this.state.codeProduct.code} imageUrl={this.state.product.companyLogoUrl}/>

        <div className={style.productInfo}>
          <div className={style.productInfoTitleContainer}>
            <span className={style.productInfoTitle}>{(this.state.product[this.state.locale] || {})['name']}</span>
            <div className={style.productInfoButton} onClick={() => {
              this.props.history.push('/user/product?id=' + params.productReleaseCode + '&eventJoin=true');
            }}>{this.props.t('product_info')}</div>
          </div>
          <span className={style.productInfoDetail}>
            <span className={style.textBold} style={{ marginRight: 8 }}>
              {this.props.t('manufacturer')}
            </span>
            {this.state.product[this.state.locale + 'CompanyName']}
          </span>
        </div>
      </Section>
    );
  }

  get renderTapSelector() {
    const { t } = this.props;
    const { selectedTap } = this.state;
    const taps = [this.props.t('authenticationi_list'), this.props.t('events_you_won')];
    const histories1 = this.state.confirmDetailList.map((item, index) => {
      return {
        title: item.confirmGeoCode.city + ', ' + item.confirmGeoCode.country,
        createdAt: item.createdAt
      }
    });
    const histories2 = this.state.logEventList.map((item, index) => {
      return {
        companyName: this.state.product[this.props.COUNTRY_CODE + 'CompanyName'],
        companyLogoUrl: this.state.product.companyLogoUrl,
        title: item[this.state.locale + 'EventName'],
        createdAt: item.prizeDate,
        eventPrize: item.eventPrize || {},
      }
    });

    return (
      <Section>
        {this.state.isLogin ? null : <LoginComponent onRef={(ref) => { this.socialLoginModal = ref;}} handleClose={this.handleCloseModal}
                                                     loginSuccess={this.handleLoginSuccess} modalContents={{title: t('welcome'), info: t('login_benefit')}}/>}
        <TapSelector
          taps={taps}
          selectedTap={selectedTap}
          onClickTap={this.onClickTap.bind(this)}
        />

        {selectedTap === 0 && <HistoryList histories={histories1 || []} type="auth"  ELocale={this.state.locale}/>}
        {selectedTap === 1 && <HistoryList histories={histories2|| []} type="event" handleModal={(item) => this.handleModal(item)}/>}
        <ModalBarcode showModal={this.state.showModal} handleModal={() => this.setState({ showModal: !this.state.showModal })} companyLogoUrl={this.state.product.companyLogoUrl} selectedItem={this.state.selectedItem || {}}/>

      </Section>
    );
  }



  render() {
    return (
        <div className={style.container}>
          <Header
              content={this.state.product[this.state.locale + 'CompanyName']}
              onClosePress={()=>{ Const.userAppCloseActivity(); }}
              onBackPress={() => this.props.history.goBack()}
          />

          <div className={style.contentContainer}>
            {this.renderProductSummary}
            {this.renderTapSelector}
          </div>
        </div>
    );
  }
}

export default connect((state) => {
  return {
    eSESSION: state.data.eSESSION.eSESSION,
    COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE,
    UUID: state.data.eSESSION.UUID,
  }
})(withRouter(withTranslation()(DetailContainer)));
